import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Demo } from './demo/Demo';

function App () {
  return (
    <Router>
      <div className="App">
        <Route path="/demo/preview/:type/:tagId/:device?">
          <Demo/>
        </Route>
      </div>
    </Router>
  );
}

export default App;
